import { render, staticRenderFns } from "./WavesTable.vue?vue&type=template&id=70f38072&scoped=true"
import script from "./WavesTable.vue?vue&type=script&lang=js"
export * from "./WavesTable.vue?vue&type=script&lang=js"
import style0 from "./WavesTable.vue?vue&type=style&index=0&id=70f38072&prod&lang=scss"
import style1 from "./WavesTable.vue?vue&type=style&index=1&id=70f38072&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f38072",
  null
  
)

export default component.exports